/**
 * A single world-modifier choice card.
 * Shows the rarity badge, list of debuffs, and reward bonuses.
 *
 * Props:
 *   mod      — modifier object { rarity, label, color, debuffs[], xpMult, goldMult, dropChanceBonus }
 *   onChoose — () → void
 */
export function ModifierCard({ mod, onChoose }) {
  return (
    <button
      className="modifier-card"
      style={{ '--mod-color': mod.color }}
      onClick={onChoose}
    >
      {/* Rarity badge */}
      <div className="modifier-rarity-badge" style={{ color: mod.color }}>
        {mod.label}
      </div>

      {/* Debuff list */}
      <div className="modifier-debuffs">
        {mod.debuffs.map(d => (
          <div key={d.id} className="modifier-debuff-row">
            <span className="modifier-debuff-label">{d.label}</span>
            <span className="modifier-debuff-desc">{d.desc}</span>
          </div>
        ))}
      </div>

      {/* Reward bonuses */}
      <div className="modifier-rewards">
        <div className="modifier-reward-row">
          <span>📈 XP gain</span>
          <span className="modifier-reward-value">×{mod.xpMult.toFixed(2)}</span>
        </div>
        <div className="modifier-reward-row">
          <span>💰 Gold gain</span>
          <span className="modifier-reward-value">×{mod.goldMult.toFixed(2)}</span>
        </div>
        <div className="modifier-reward-row">
          <span>🎁 Item drops</span>
          <span className="modifier-reward-value">+{(mod.dropChanceBonus * 100).toFixed(1)}%</span>
        </div>
      </div>
    </button>
  );
}
